'use client';
import { Box, Button, Grid, Link, Typography } from '@mui/material';
import styles from './help.module.scss';
import RouterLink from 'next/link';
import { useTranslation, Trans } from 'react-i18next';

const Help = () => {
  const { t } = useTranslation();

  return (
    <>
      <Grid size={{ xs: 12, sm: 6 }} sx={{ justify: 'center', mt: 1 }}>
        <Box sx={{ color: 'secondary.main', mb: 2 }} className={styles.box}>
          <img alt='complex' style={{ margin: 16 }} src='/images/kids-children.jpg' />
          <br />
          <Typography variant='h3' style={{ fontSize: 22, textTransform: 'none' }} className={styles.typography}>
            {t('help-page.section-1.heading')}
          </Typography>
          <Typography
            variant='subtitle1'
            align='left'
            style={{ fontSize: 18, margin: 8 }}
            className={styles.typography}
          >
            <ul>
              <Trans i18nKey='help-page.section-1.list1'>
                <li>
                  Click the{' '}
                  <Link
                    sx={{ color: 'white', textDecoration: 'underline' }}
                    component={RouterLink}
                    href='/quiz-options'
                  >
                    quiz options
                  </Link>{' '}
                  link.
                </li>
              </Trans>
              <li>{t('help-page.section-1.list2')}</li>
              <li>{t('help-page.section-1.list3')}</li>
              <li>{t('help-page.section-1.list4')}</li>
              <li>{t('help-page.section-1.list5')}</li>
              <li>{t('help-page.section-1.list6')}</li>
              <li>{t('help-page.section-1.list7')}</li>
              <li>{t('help-page.section-1.list8')}</li>
            </ul>
          </Typography>
          <Button
            sx={{ marginBottom: 2 }}
            component={RouterLink}
            href='/quiz-options'
            color='secondary'
            variant='contained'
            className={styles.typography}
          >
            {t('help-page.section-1.buttonText')}
          </Button>
        </Box>
      </Grid>
      <Grid size={{ md: 1 }} />
      <Grid size={{ xs: 12, sm: 6, md: 5, lg: 5, xl: 5 }} sx={{ justify: 'center', mt: 1 }}>
        <Box sx={{ mb: 2 }} className={styles.box}>
          <img alt='complex' src='/images/kids-wearing.jpg' style={{ margin: 16 }} />
          <Typography variant='h3' style={{ fontSize: 22, textTransform: 'none' }} className={styles.typography}>
            {t('help-page.section-2.heading')}
          </Typography>
          <Typography
            variant='subtitle1'
            align='justify'
            style={{ fontSize: 18, margin: 16 }}
            className={styles.typography}
          >
            <p>{t('help-page.section-2.para-1')}</p>
            <p>{t('help-page.section-2.para-2')}</p>
            <p>{t('help-page.section-2.para-3')}</p>
            <p>{t('help-page.section-2.para-4')}</p>
          </Typography>
          <Button
            component={RouterLink}
            sx={{ marginBottom: 2 }}
            href='/learn-tables'
            variant='contained'
            color='secondary'
            className={styles.typography}
          >
            {t('help-page.section-2.buttonText')}
          </Button>
        </Box>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }} sx={{ justify: 'center' }}>
        <Box className={styles.box}>
          <img alt='complex' src='/images/Pattern.jpg' style={{ margin: 16 }} />
          <Typography variant='h3' style={{ fontSize: 22, textTransform: 'none' }} className={styles.typography}>
            {t('help-page.section-3.heading')}
          </Typography>
          <Typography
            variant='subtitle1'
            align='justify'
            style={{ fontSize: 18, margin: 16 }}
            className={styles.typography}
          >
            <p>
              {t('help-page.section-3.para-1', {
                currentMonth: new Date(),
              })}
            </p>
          </Typography>
          <Button
            component={RouterLink}
            sx={{ marginBottom: 2 }}
            href='/learn-tables'
            variant='contained'
            className={styles.typography}
            color='secondary'
          >
            {t('help-page.section-3.buttonText')}
          </Button>
        </Box>
      </Grid>
      <Grid size={{ md: 1 }} />
    </>
  );
};
export default Help;
